import { doc, runTransaction } from 'firebase/firestore'
import {
  formatInventoryLeadNumber,
  INVENTORY_LEAD_NUMBER_COUNTER_COLLECTION,
  INVENTORY_LEAD_NUMBER_COUNTER_DOC_ID,
} from '@otw/models/leads/inventoryLeadNumber'
import { db as firestore } from 'config/firebase'

/**
 * Atomically allocates the next inventory lead number from
 * `counters/inventory_lead_numbers`.
 */
export const allocateInventoryLeadNumber = async (
  createdAt: Date = new Date(),
): Promise<string> => {
  const counterRef = doc(
    firestore,
    INVENTORY_LEAD_NUMBER_COUNTER_COLLECTION,
    INVENTORY_LEAD_NUMBER_COUNTER_DOC_ID,
  )

  return runTransaction(firestore, async (transaction) => {
    const counterSnap = await transaction.get(counterRef)
    const nextSequence = counterSnap.exists()
      ? Math.max(1, Number(counterSnap.data()?.next) || 1)
      : 1

    const leadNumber = formatInventoryLeadNumber(nextSequence, createdAt)
    transaction.set(counterRef, { next: nextSequence + 1 }, { merge: true })
    return leadNumber
  })
}
